import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getPlans, } from "../../store/slices/plan";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function UserMembership() {
  const { planslist = [], loading } = useSelector((state) => state.plan);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getPlans());
  }, [dispatch]);

  const getFeatureList = (plan) => {
    const durationLabel =
      plan.durationType === "years"
        ? plan.duration > 1
          ? "Years"
          : "Year"
        : plan.duration > 1
          ? "Months"
          : "Month";

    return [
      {
        text: `Valid for ${plan.duration} ${durationLabel}`,
        enabled: true,
      },
      {
        text:
          plan.limits?.chats === -1
            ? "Unlimited Chat"
            : `${plan.limits?.chats || 0} Chats`,
        enabled: true,
      },
      {
        text:
          plan.limits?.contactViews === -1
            ? "Unlimited Contact Views"
            : `${plan.limits?.contactViews || 0} Contact Views`,
        enabled: true,
      },
      {
        text: "Verified Badge",
        enabled: !!plan.features?.verifiedBadge,
      },
      {
        text: "Profile Highlight",
        enabled: !!plan.features?.profileHighlight,
      },
    ];
  };
  const isBestSeller = (index) => index === 2;

  return (
    <>
      {/* Header <--- > */}
      <div className="membership-header">
        <h1>Membership Plans</h1>
      </div>

      {/* <--- >Plans */}
      <Container className="plans-section">
        {loading ? (
          <Row className="justify-content-center">
            {Array.from({ length: 3 }).map((_, index) => (
              <Col lg={3} md={6} key={index} className="mb-4">
                <div className="plan-card ep-skeleton-card">


                  <div className="ep-skeleton-line" style={{ width: "90px", height: "24px", borderRadius: "20px", margin: "0 auto 12px auto" }} />


                  <div className="ep-skeleton-title" style={{ width: "55%", margin: "0 auto 8px auto" }} />


                  <div className="ep-skeleton-line short" style={{ width: "40%", margin: "0 auto 10px auto" }} />


                  <div className="ep-skeleton-line" style={{ width: "85%", margin: "0 auto 6px auto" }} />
                  <div className="ep-skeleton-line" style={{ width: "70%", margin: "0 auto 12px auto" }} />


                  <div className="ep-skeleton-line" style={{ width: "45%", height: "32px", borderRadius: "6px", margin: "0 auto 8px auto" }} />


                  <div className="ep-skeleton-line short" style={{ width: "55%", margin: "0 auto 16px auto" }} />


                  <ul className="plan-features" style={{ listStyle: "none", padding: 0 }}>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <li key={i} style={{ marginBottom: "8px" }}>
                        <div className="ep-skeleton-line" style={{ width: `${70 + (i % 3) * 10}%`, height: "14px" }} />
                      </li>
                    ))}
                  </ul>

                  {/* Buy button */}
                  <div className="ep-skeleton-line" style={{ width: "100%", height: "42px", borderRadius: "8px", marginTop: "12px" }} />
                </div>
              </Col>
            ))}
          </Row>
        ) : planslist.length === 0 ? (
          <div className="plans-loading">Loading plans...</div>
        ) : (
          <Row className="justify-content-center">
            {planslist.map((plan, index) => (
              <Col lg={3} md={6} xl={3} key={plan._id} className="mb-4">
                <div className="plan-card">
                  {/* {isBestSeller(index) && (
                    <div className="bestseller-badge">Best Seller</div>
                  )} */}

                  <h4 className="plan-name text-center">{plan.name}</h4>

                  {plan.description && (
                    <p className="plan-description text-center">
                      {plan.description}
                    </p>
                  )}

                  <div className="text-center mt-2">
                    {plan.originalPrice && plan.originalPrice > plan.price && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "6px",
                        }}
                      >
                        <span
                          style={{
                            background: "#28a745",
                            color: "#fff",
                            fontSize: "12px",
                            padding: "3px 10px",
                            borderRadius: "20px",
                            fontWeight: "600",
                          }}
                        >
                          {Math.round(
                            ((plan.originalPrice - plan.price) / plan.originalPrice) * 100
                          )}
                          % OFF
                        </span>

                        <span
                          style={{
                            fontSize: "20px",
                            color: "#393838",
                            textDecoration: "line-through",
                            fontWeight: 500,
                          }}
                        >
                          ₹{plan.originalPrice.toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}

                    <div>
                      <span
                        className="plan-price"
                        style={{
                          fontSize: "32px",
                          fontWeight: "700",
                          color: "#7b1e3b",
                        }}
                      >
                        ₹{plan.price.toLocaleString("en-IN")}
                      </span>
                    </div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        marginTop: "6px",
                      }}
                    >
                      * Taxes as applicable (18% GST extra)
                    </div>
                  </div>


                  {/* <div className="text-center mt-2">
                    <span className="plan-monthly">
                      ₹
                      {Math.round(
                        plan.price /
                        (plan.durationType === "years"
                          ? plan.duration * 12
                          : plan.duration)
                      ).toLocaleString("en-IN")}
                      {" / month"}
                    </span>
                  </div> */}

                  {/*  Feature List <-------- */}
                  <ul className="plan-features">
                    {getFeatureList(plan).map((feature, index) => (
                      <li
                        key={index}
                        style={{
                          color: feature.enabled ? "#000" : "#999",
                          opacity: feature.enabled ? 1 : 0.6,
                        }}
                      >
                        {feature.enabled ? "✔" : "✖"} {feature.text}
                      </li>
                    ))}
                  </ul>
                  {/* Pay Button */}
                  <button
                    className="plan-pay-btn"
                    onClick={() =>
                      navigate(`/user/checkout`, { state: { plan } })
                    }
                  >
                    Buy Subscription
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </>
  );
}
